/**
 * Computing target element center position value.
 */
export const computeTargetCenter = (target: HTMLElement | HTMLDivElement) => {
  const horizontal = target.offsetLeft + target.clientWidth / 2;
  const vertical = target.offsetTop + target.clientHeight / 2;

  return { horizontal, vertical };
};
